import i18n from "../i18n";

const PERIODO_API_TO_KEY = {
  Vigente: "current",
  "1 a 30 días": "aging1_30",
  "31 a 60 días": "aging31_60",
  "61 a 90 días": "aging61_90",
  "91 a 120 días": "aging91_120",
  "+ 120 días": "aging120plus",
  "+120 días": "aging120plus",
};

export const AGING_OVERDUE_API_ORDER = [
  "1 a 30 días",
  "31 a 60 días",
  "61 a 90 días",
  "91 a 120 días",
  "+ 120 días",
];

export function translateAgingPeriod(periodo) {
  const key = PERIODO_API_TO_KEY[periodo];
  if (!key) return periodo || "";
  return i18n.t(`reports:excel.${key}`);
}

export function agingOverdueChartLabels() {
  return AGING_OVERDUE_API_ORDER.map(translateAgingPeriod);
}

export function getDebtExcelLabels(entityLabel) {
  const t = (key, opts) => i18n.t(`reports:excel.${key}`, opts);
  return {
    period: t("period"),
    amount: t("amount"),
    percentOfTotal: t("percentOfTotal"),
    totalDebt: t("totalDebt"),
    ranking: t("ranking"),
    totalAmount: t("totalAmount"),
    documents: t("documents"),
    current: t("current"),
    totalCurrent: t("totalCurrent"),
    totalDocs: t("totalDocs"),
    folio: t("folio"),
    balance: t("balance"),
    label: t("label"),
    entity: entityLabel,
    sheetSummaryByPeriod: t("sheetSummaryByPeriod"),
    sheetDetailByPeriod: t("sheetDetailByPeriod"),
    sheetDetail: t("sheetDetail"),
    agingBuckets: [
      { periodo: t("current"), key: "vigente" },
      { periodo: t("aging1_30"), key: "d1_30" },
      { periodo: t("aging31_60"), key: "d31_60" },
      { periodo: t("aging61_90"), key: "d61_90" },
      { periodo: t("aging91_120"), key: "d91_120" },
      { periodo: t("aging120plus"), key: "d120p" },
    ],
    translatePeriod: translateAgingPeriod,
  };
}

export function getDetailExcelLabels(entityLabel, mode = "sales") {
  const ns = mode === "purchases" ? "excel.detailPurchases" : "excel.detailSales";
  const t = (key, opts) => i18n.t(`reports:${ns}.${key}`, opts);
  return {
    month: t("month"),
    year: t("year"),
    amount: t("amount"),
    ranking: t("ranking"),
    percentOfTotal: t("percentOfTotal"),
    periodTotal: t("periodTotal"),
    grandTotal: t("grandTotal"),
    totalPercent: t("totalPercent"),
    totalCount: t("totalCount"),
    transactionCount: t("transactionCount"),
    folio: t("folio"),
    date: t("date"),
    entity: entityLabel,
    sheetMonthlySummary: t("sheetMonthlySummary"),
    sheetEntities: t("sheetEntities"),
    sheetDetailByMonth: t("sheetDetailByMonth"),
    sheetDetail: t("sheetDetail"),
  };
}
